<template>
  <div>
    <el-button @click="showImportUserDlg" style="height:28px" size="mini" type="primary">{{btntitle ? btntitle : '导入'}}</el-button>
    <ImportUserFDlg :params="params" :title="title" :download="download" :href="href" :url="url" :prompt="prompt"  ref="importUserDlg" @refreshTable="search"></ImportUserFDlg>
  </div>
</template>

<script>
import ImportUserFDlg from './ImportUserFDlg'
export default {
  props: {
    title: String,
    href: String,
    url: String,
    download: String,
    unitId: Number,
    btntitle: String,
    params: Object,
    prompt: String,
  },
  components: {
    ImportUserFDlg
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 导入
    showImportUserDlg () {
      this.$refs['importUserDlg'].showImportUserDlg()
    },
    search () {
      this.$emit('refreshTable')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/Util/importantBtn.vue